import React from 'react'
import { Typography, Alert } from '@the-platform-group/component-library'
import { usePeopleMergeContext } from '../../contexts/PeopleMergeContext'
import { getJobTitleAndOrgName } from '../../utils'

const PreviewAlerts = ({ activeStep }) => {
  const { mergeData, jobMappingData } = usePeopleMergeContext()
  const { selectedData, mergePreviewMeta } = mergeData
  const { sourceJobs } = selectedData
  const { isBlocked, previewErrors, blockedSourceJobIds } = mergePreviewMeta
  const { mappedSourceJobIds } = jobMappingData

  const unmappedBlockedJobs = sourceJobs.filter(
    job => blockedSourceJobIds?.includes(job.id) && !mappedSourceJobIds.includes(job.id),
  )

  return (
    <>
      {previewErrors?.length > 0 && (
        <Alert severity={isBlocked ? 'error' : 'warning'} sx={{ alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="body2" fontWeight="bold" gutterBottom>
            {isBlocked ? 'Merge blocked:' : 'Merge warnings:'}
          </Typography>
          {previewErrors.map((err, idx) => (
            <Typography key={idx} variant="body2">
              {err.profile}: {err.message}
            </Typography>
          ))}
        </Alert>
      )}
      {/* Unmapped blocking jobs - only show on job mapping step */}
      {activeStep === 1 && unmappedBlockedJobs.length > 0 && (
        <Alert severity="warning" sx={{ alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="body2" fontWeight="bold" gutterBottom>
            You can't proceed until all jobs with affiliations are mapped.
          </Typography>
          {unmappedBlockedJobs.map(job => (
            <Typography key={job.id} variant="body2">
              - {getJobTitleAndOrgName(job)}
            </Typography>
          ))}
        </Alert>
      )}
    </>
  )
}

export default PreviewAlerts
